(function () {
  'use strict';
  var _cfg = null;
  function cfg() {
    if (!_cfg) {
      try {
        var u = window.BSSAutoAddGiftConfig || {};
        _cfg = {
          debug:        u.debug === true,
          triggerDelay: typeof u.triggerDelay === 'number' ? u.triggerDelay : 700,
          pollInterval: typeof u.pollInterval === 'number' ? u.pollInterval : 1500,
          pollMaxTime:  typeof u.pollMaxTime  === 'number' ? u.pollMaxTime  : 45000,
        };
      } catch (e) { _cfg = { debug: false, triggerDelay: 700, pollInterval: 1500, pollMaxTime: 45000 }; }
    }
    return _cfg;
  }

  function log() {
    try { if (cfg().debug) console.log.apply(console, ['[BSS AutoGift]'].concat([].slice.call(arguments))); }
    catch (e) { /* ignore */ }
  }
  var _native = window.fetch;
  function root() { return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/'; }

  function fetchCart() {
    return _native.call(window, root() + 'cart.js', {
      credentials: 'same-origin', headers: { 'Content-Type': 'application/json' },
    }).then(function (r) { return r.json(); });
  }

  function addToCart(items) {
    return _native.call(window, root() + 'cart/add.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items }),
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (b) { throw new Error(b.description || 'HTTP ' + r.status); });
      return r.json();
    });
  }

  function applyDiscount(code) {
    if (!code) return Promise.resolve();
    return _native.call(window, root() + 'discount/' + encodeURIComponent(code), { credentials: 'same-origin' })
      .catch(function () { /* best-effort */ });
  }

  /* ============================================================
     INSPECT tlFreeGiftOffer – log cấu trúc để debug
     ============================================================ */
  function inspectOffer(offer) {
    if (!cfg().debug) return;
    try {
      var keys = Object.keys(offer);
      log('=== tlFreeGiftOffer keys ===', keys.join(', '));

      // Log các field quan trọng
      var fields = ['displayRules', 'rules', 'ruleData', 'rulesList', 'ruleList',
                    'embedWidget', 'popupWidget', 'widget', 'advancedWidget',
                    'checkAndAddGifts', 'evaluateRules', 'syncGifts', 'triggerCheck',
                    'handleAddGifts', 'refreshCartContent', 'ruleIdMapGifts'];
      fields.forEach(function (f) {
        var v = offer[f];
        if (v !== undefined) {
          var type = typeof v;
          var preview = type === 'function' ? 'function()' :
                        (v && typeof v.size === 'number' ? 'Map/Set(size=' + v.size + ')' :
                        (Array.isArray(v) ? 'Array[' + v.length + ']' :
                        JSON.stringify(v).slice(0, 80)));
          log('  offer.' + f + ' =', preview);
        }
      });

      // Tìm mọi function trong offer
      var fns = keys.filter(function (k) { return typeof offer[k] === 'function'; });
      log('  Functions:', fns.join(', '));

      // Tìm widget objects
      keys.forEach(function (k) {
        var v = offer[k];
        if (v && typeof v === 'object' && !Array.isArray(v) && !(v instanceof Map) && !(v instanceof Set)) {
          var subFns = Object.keys(v).filter(function (sk) { return typeof v[sk] === 'function'; });
          if (subFns.length > 0) {
            log('  offer.' + k + ' (object) functions:', subFns.slice(0, 15).join(', '));
          }
        }
      });
    } catch (e) { log('inspectOffer error:', e); }
  }

  /* ============================================================
     GIFT DETECTION
     ============================================================ */
  function isGiftItem(item) {
    try {
      var offer = window.tlFreeGiftOffer;
      if (offer && typeof offer.checkLineItemIsGift === 'function' && offer.checkLineItemIsGift(item)) return true;
    } catch (e) { /* ignore */ }
    try {
      var p = item.properties || {};
      if (Object.keys(p).some(function (k) { return k.charAt(0) === '_'; })) return true;
    } catch (e) { /* ignore */ }
    return false;
  }

  function getRuleId(item) {
    var keys = ['_salepify-embed', '_salepify-advanced-fg', '_salepify-bogo'];
    var p = item.properties || {};
    for (var i = 0; i < keys.length; i++) {
      if (p[keys[i]] != null && p[keys[i]] !== '') return Number(p[keys[i]]);
    }
    return null;
  }

  /* ============================================================
     GET RULES – thử nhiều path trong offer object
     ============================================================ */
  function getRules(offer) {
    // Path 1: embedWidget
    var embed = offer.embedWidget;
    if (embed) {
      if (typeof embed.getDisplayRules === 'function') {
        var r = embed.getDisplayRules(); if (r && r.length) return r;
      }
      if (Array.isArray(embed.displayRules) && embed.displayRules.length) return embed.displayRules;
    }

    // Path 2: các widget khác
    var widgetKeys = Object.keys(offer).filter(function (k) {
      var v = offer[k];
      return v && typeof v === 'object' && !Array.isArray(v) && !(v instanceof Map);
    });
    for (var i = 0; i < widgetKeys.length; i++) {
      var w = offer[widgetKeys[i]];
      if (typeof w.getDisplayRules === 'function') {
        var wr = w.getDisplayRules(); if (wr && wr.length) { log('Rules via offer.' + widgetKeys[i] + '.getDisplayRules'); return wr; }
      }
      if (Array.isArray(w.displayRules) && w.displayRules.length) {
        log('Rules via offer.' + widgetKeys[i] + '.displayRules'); return w.displayRules;
      }
      if (Array.isArray(w.rules) && w.rules.length) {
        log('Rules via offer.' + widgetKeys[i] + '.rules'); return w.rules;
      }
    }

    // Path 3: trực tiếp trên offer
    var directPaths = ['displayRules', 'rules', 'ruleData', 'rulesList', 'ruleList', 'offerRules'];
    for (var j = 0; j < directPaths.length; j++) {
      var arr = offer[directPaths[j]];
      if (Array.isArray(arr) && arr.length) { log('Rules via offer.' + directPaths[j]); return arr; }
    }

    return [];
  }

  /* ============================================================
     CHECK RULE CONDITION
     ============================================================ */
  function ruleMet(rule, cartItems) {
    var paid = 0;
    cartItems.forEach(function (item) {
      if (!isGiftItem(item)) paid += (item.final_line_price != null ? item.final_line_price : (item.line_price || 0));
    });
    var threshold = rule.goal_value || rule.minimum_order_amount || rule.minimum_purchase_amount
      || rule.cart_minimum_price || rule.min_cart_value || rule.minCartValue || rule.goalValue || 0;
    log('Rule', rule.id, '| paid:', paid, '| threshold:', threshold, '| met:', paid >= threshold);
    return threshold === 0 || paid >= threshold;
  }

  /* ============================================================
     STRATEGY 1: Gọi method của BSS app để tự xử lý
     ============================================================ */
  function tryAppMethods(offer) {
    var methods = [
      'checkAndAddGifts', 'checkGifts', 'evaluateRules', 'syncGifts',
      'triggerGiftCheck', 'addGiftsIfQualified', 'processCart',
      'handleCartUpdate', 'onCartUpdate', 'recheck', 'recalculate',
      'checkCart', 'validateCart', 'autoAddGifts',
    ];

    // Thử trên offer trực tiếp
    for (var i = 0; i < methods.length; i++) {
      if (typeof offer[methods[i]] === 'function') {
        log('Calling offer.' + methods[i] + '()');
        try { offer[methods[i]](); return true; } catch (e) { log('Error:', e.message); }
      }
    }

    // Thử trên mọi object property của offer
    var keys = Object.keys(offer);
    for (var j = 0; j < keys.length; j++) {
      var v = offer[keys[j]];
      if (!v || typeof v !== 'object' || Array.isArray(v) || v instanceof Map) continue;
      for (var k = 0; k < methods.length; k++) {
        if (typeof v[methods[k]] === 'function') {
          log('Calling offer.' + keys[j] + '.' + methods[k] + '()');
          try { v[methods[k]](); return true; } catch (e) { log('Error:', e.message); }
        }
      }
    }

    return false;
  }

  /* ============================================================
     STRATEGY 2: Dispatch events mà BSS app lắng nghe
     ============================================================ */
  function dispatchEvents(cart) {
    [
      'TLFREEGIFT:cartUpdated', 'TLFREEGIFT:change', 'TLFREEGIFT:update',
      'cart:updated', 'theme:cart:updated', 'cart-update', 'cart:refresh',
    ].forEach(function (name) {
      try {
        var ev = new CustomEvent(name, { detail: { cart: cart }, bubbles: true });
        document.dispatchEvent(ev); window.dispatchEvent(ev);
      } catch (e) { /* ignore */ }
    });
  }

  /* ============================================================
     STRATEGY 3: Direct add – dùng khi biết rule + variant
     ============================================================ */
  function directAdd(rule, cartItems, offer) {
    var ruleId = rule.id;
    var children = rule.listChilds || rule.gifts || rule.giftVariants || rule.variants || [];
    if (!children.length) { log('Rule', ruleId, '- no children'); return Promise.resolve(); }

    // Nhiều gift → cần user chọn
    if (children.length > 1 && !rule.is_gift_qty_fixed) {
      log('Rule', ruleId, '- multiple gifts, user must pick');
      return Promise.resolve();
    }

    var maxQty = rule.gift_quantity || rule.max_gift_quantity || rule.gift_qty || 1;
    var existingCount = 0;
    var existingVids = {};
    cartItems.forEach(function (item) {
      if (!isGiftItem(item)) return;
      var rid = getRuleId(item);
      if (rid === ruleId || rid === null) {
        existingCount += (item.quantity || 1);
        existingVids[String(item.variant_id)] = true;
      }
    });

    if (existingCount >= maxQty) { log('Rule', ruleId, '- already has', existingCount, '/', maxQty, 'gifts'); return Promise.resolve(); }

    var child = null;
    for (var i = 0; i < children.length; i++) {
      var vid = String(children[i].shopify_id || children[i].variant_id || children[i].id || '');
      if (vid && !existingVids[vid]) { child = children[i]; break; }
    }
    if (!child) { log('Rule', ruleId, '- all gifts already in cart'); return Promise.resolve(); }

    var variantId = child.shopify_id || child.variant_id || child.id;
    var qty = Math.min(child.quantity || 1, maxQty - existingCount);

    // Build item
    var embed = offer.embedWidget;
    var propKey = '_salepify-embed';
    try {
      // Tìm propKey phù hợp với module
      var keys = Object.keys(offer);
      for (var j = 0; j < keys.length; j++) {
        var w = offer[keys[j]];
        if (w && w.constants && w.constants.MODULE_MAP_PROPERTY && rule.module && w.constants.MODULE_MAP_PROPERTY[rule.module]) {
          propKey = w.constants.MODULE_MAP_PROPERTY[rule.module]; break;
        }
      }
    } catch (e) { /* ignore */ }

    var props = {}; props[propKey] = ruleId;
    var item = { id: Number(variantId), quantity: qty, properties: props };

    log('Rule', ruleId, '- adding variantId:', variantId, 'qty:', qty, 'propKey:', propKey);

    // Thử handleAddGifts của offer
    if (typeof offer.handleAddGifts === 'function') {
      var codes = rule.discount_code ? [rule.discount_code] : [];
      return offer.handleAddGifts([item], codes, [])
        .then(function (res) {
          if (res && (res.status === 200 || res.items)) {
            log('Rule', ruleId, '- handleAddGifts OK');
            return afterAdd(offer);
          }
          return addDirect([item], rule, offer);
        })
        .catch(function (e) { log('handleAddGifts error:', e.message); return addDirect([item], rule, offer); });
    }

    return addDirect([item], rule, offer);
  }

  function addDirect(items, rule, offer) {
    log('addDirect via cart/add.js');
    return addToCart(items)
      .then(function () { return applyDiscount(rule && rule.discount_code); })
      .then(function () { return afterAdd(offer); })
      .catch(function (e) { console.warn('[BSS AutoGift] addDirect failed:', e.message); });
  }

  function afterAdd(offer) {
    log('afterAdd – refreshing...');
    // Cooldown đã được set trong runCheck trước khi add.
    // Đây là lần refresh cuối – sau đó không check thêm nữa.
    if (offer && typeof offer.refreshCartContent === 'function') {
      // Wrap refreshCartContent để phát hiện nếu nó gây reload
      try {
        var p = offer.refreshCartContent();
        if (p && typeof p.then === 'function') {
          return p.catch(function () { return fallbackRefresh(); });
        }
      } catch (e) { /* ignore */ }
    }
    return fallbackRefresh();
  }

  function fallbackRefresh() {
    // KHÔNG dispatch cart:updated ở đây để tránh trigger runCheck lại.
    // Chỉ update UI tối thiểu.
    return fetchCart().then(function (cart) {
      try {
        document.querySelectorAll('.cart-count-bubble,.cart__count,[data-cart-count],[data-cart-item-count],#cart-count')
          .forEach(function (el) {
            var c = cart.item_count;
            if      (el.hasAttribute('data-cart-count'))       el.setAttribute('data-cart-count', c);
            else if (el.hasAttribute('data-cart-item-count'))  el.setAttribute('data-cart-item-count', c);
            else el.textContent = c;
          });
      } catch (e) { /* ignore */ }

      // Dùng _selfEvent flag để tạm chặn listenCartEvents trong khi dispatch
      _selfEvent = true;
      try {
        // Chỉ dispatch sections:load (để theme re-render cart drawer)
        // KHÔNG dispatch cart:updated để tránh loop
        try { document.dispatchEvent(new CustomEvent('sections:load', { bubbles: true })); } catch (e) { /* */ }
        // Theme-specific APIs
        try { if (window.theme && window.theme.cart && typeof window.theme.cart.getCart === 'function') window.theme.cart.getCart(); } catch (e) { /* */ }
        try { if (window.Shopify && typeof window.Shopify.onCartUpdate === 'function') window.Shopify.onCartUpdate(cart); } catch (e) { /* */ }
      } finally {
        // Mở lại listener sau 1 tick
        setTimeout(function () { _selfEvent = false; }, 0);
      }

      log('Cart refreshed. item_count =', cart.item_count);
      // Xóa cooldown sau 15s (được tự xóa khi hết thời gian)
    }).catch(function (e) { console.warn('[BSS AutoGift] fallbackRefresh error:', e); });
  }

  /* ============================================================
     COOLDOWN – chống vòng lặp vô hạn
     Dùng sessionStorage để lock ngay cả khi page bị reload.
     ============================================================ */
  var COOLDOWN_KEY = 'bss_autogift_lock';
  var COOLDOWN_MS  = 15000; // 15 giây sau khi add xong mới cho check tiếp

  function setCooldown() {
    try { sessionStorage.setItem(COOLDOWN_KEY, String(Date.now())); } catch (e) { /* ignore */ }
  }

  function isInCooldown() {
    try {
      var t = Number(sessionStorage.getItem(COOLDOWN_KEY) || 0);
      return t > 0 && (Date.now() - t) < COOLDOWN_MS;
    } catch (e) { return false; }
  }

  function clearCooldown() {
    try { sessionStorage.removeItem(COOLDOWN_KEY); } catch (e) { /* ignore */ }
  }

  // Flag chặn self-event (cart events do chính script dispatch)
  var _selfEvent = false;

  /* ============================================================
     MAIN CHECK
     ============================================================ */
  var _busy = false;

  function runCheck(reason) {
    // Bỏ qua nếu đang trong cooldown (vừa add gift xong)
    if (isInCooldown()) { log('In cooldown, skip [' + reason + ']'); return; }
    // Bỏ qua nếu event do chính script dispatch
    if (_selfEvent)     { log('Self-event, skip [' + reason + ']'); return; }
    if (_busy)          { log('Busy, skip [' + reason + ']'); return; }

    var offer = window.tlFreeGiftOffer;
    if (!offer) { log('No offer [' + reason + ']'); return; }

    log('=== runCheck [' + reason + '] ===');
    if (reason === 'init') inspectOffer(offer);

    _busy = true;

    // Strategy 1: let BSS app handle (không gọi nếu không có rules)
    // tryAppMethods sẽ được gọi CHỈ khi direct add thành công

    fetchCart().then(function (cart) {
      var cartItems = cart.items || [];
      var rules = getRules(offer);

      log('cartItems:', cartItems.length, '| rules found:', rules.length);

      if (!rules.length) {
        // Không có rules → KHÔNG dispatch events (tránh loop)
        log('No rules data → skip');
        _busy = false;
        return;
      }

      var qualified = rules.filter(function (r) {
        var autoAdd = r.auto_add === true || r.auto_add == null || r.is_auto_add === true;
        return autoAdd && ruleMet(r, cartItems);
      });

      log('Qualified rules:', qualified.map(function (r) { return r.id; }));

      if (!qualified.length) { _busy = false; return; }

      // Set cooldown TRƯỚC khi add để chặn loop ngay lập tức
      setCooldown();

      return qualified.reduce(function (p, rule) {
        return p.then(function () { return directAdd(rule, cartItems, offer); });
      }, Promise.resolve());
    })
    .catch(function (e) { console.warn('[BSS AutoGift] runCheck error:', e); clearCooldown(); })
    .then(function () { _busy = false; });
  }

  /* ============================================================
     DEBOUNCE
     ============================================================ */
  var _timer = null;
  function schedule(delay, reason) {
    clearTimeout(_timer);
    _timer = setTimeout(function () { runCheck(reason || 'scheduled'); },
      delay != null ? delay : cfg().triggerDelay);
  }

  /* ============================================================
     INTERCEPT fetch – phát hiện add non-gift product
     ============================================================ */
  function patchFetch() {
    var prev;
    try { prev = window.fetch; } catch (e) { return; }
    if (!prev) return;

    try {
      window.fetch = function bssAutoGift(resource, init) {
        // ── SAFETY: nếu bất kỳ lỗi nào xảy ra trong logic của chúng ta,
        //    luôn fallback về native fetch để cart add của theme vẫn hoạt động.
        var nativeCall = prev.apply(this, arguments); // gọi native TRƯỚC

        try {
          var url = typeof resource === 'string' ? resource : ((resource && resource.url) || '');
          var method = ((init && init.method) || 'GET').toUpperCase();

          if (method === 'POST' && /cart\/add(\.js)?(\?|$)/.test(url)) {
            // Attach side-effect sau khi native fetch resolve – không can thiệp chain
            return nativeCall.then(function (resp) {
              try {
                if (resp && resp.ok) {
                  try {
                    resp.clone().json().then(function (body) {
                      try {
                        var items = body.items || (body.id ? [body] : []);
                        var hasNonGift = items.some(function (it) {
                          try {
                            var p = it.properties || {};
                            return !Object.keys(p).some(function (k) { return k.charAt(0) === '_'; });
                          } catch (e) { return true; }
                        });
                        if (hasNonGift) schedule(null, 'cart/add non-gift');
                      } catch (e) { /* ignore – side effect only */ }
                    }).catch(function () {
                      try { schedule(null, 'cart/add (parse fail)'); } catch (e) { /* ignore */ }
                    });
                  } catch (e) { /* clone/json error – ignore */ }
                }
              } catch (e) { /* response inspection error – ignore */ }
              return resp; // luôn trả về response gốc
            }).catch(function (err) {
              // native fetch reject (network error v.v.) → re-throw để caller xử lý
              return Promise.reject(err);
            });
          }
        } catch (e) {
          console.warn('[BSS AutoGift] fetch hook logic error:', e);
          // Trả về native call đã gọi từ trước
        }

        return nativeCall;
      };
      log('fetch patched');
    } catch (e) {
      console.warn('[BSS AutoGift] patch fetch error:', e);
      // Đảm bảo window.fetch không bị undefined nếu patch thất bại
      try { if (!window.fetch) window.fetch = prev; } catch (e2) { /* ignore */ }
    }
  }

  /* ============================================================
     INTERCEPT XHR
     ============================================================ */
  function patchXHR() {
    var origOpen, origSend;
    try {
      origOpen = XMLHttpRequest.prototype.open;
      origSend = XMLHttpRequest.prototype.send;
    } catch (e) { return; }
    if (!origOpen || !origSend) return;

    try {
      XMLHttpRequest.prototype.open = function (m, u) {
        try {
          this._agM = (m || '').toUpperCase();
          this._agU = u || '';
        } catch (e) { /* ignore – tracking only */ }
        return origOpen.apply(this, arguments); // luôn gọi native
      };
    } catch (e) {
      console.warn('[BSS AutoGift] XHR open patch error:', e);
    }

    try {
      XMLHttpRequest.prototype.send = function () {
        try {
          var xhr = this;
          if (xhr._agM === 'POST' && /cart\/add(\.js)?(\?|$)/.test(xhr._agU || '')) {
            try {
              xhr.addEventListener('load', function () {
                try {
                  if (xhr.status === 200) schedule(null, 'XHR cart/add');
                } catch (e) { /* ignore */ }
              });
            } catch (e) { /* addEventListener failed – ignore */ }
          }
        } catch (e) { /* tracking error – ignore, still call native */ }

        return origSend.apply(this, arguments); // luôn gọi native
      };
      log('XHR patched');
    } catch (e) {
      console.warn('[BSS AutoGift] XHR send patch error:', e);
      // Khôi phục nếu send patch bị lỗi một phần
      try { XMLHttpRequest.prototype.send = origSend; } catch (e2) { /* ignore */ }
    }
  }

  /* ============================================================
     CART EVENT LISTENERS
     ============================================================ */
  function listenCartEvents() {
    try {
      ['cart:updated', 'theme:cart:updated', 'cart-update', 'CART_UPDATE'].forEach(function (ev) {
        try {
          document.addEventListener(ev, function () {
            try {
              if (_selfEvent) { log('Ignored self-event [' + ev + ']'); return; }
              schedule(null, ev);
            } catch (e) { /* ignore */ }
          });
        } catch (e) { console.warn('[BSS AutoGift] addEventListener error for', ev, e); }
      });
      log('Cart events registered');
    } catch (e) { console.warn('[BSS AutoGift] listenCartEvents error:', e); }
  }

  /* ============================================================
     POLL until offer ready, then run once
     ============================================================ */
  function poll() {
    try {
      var config = cfg();
      var elapsed = 0;
      var ran = false;

      var id = setInterval(function () {
        try {
          elapsed += config.pollInterval;

          try {
            var offer = window.tlFreeGiftOffer;
            if (offer && !ran) {
              ran = true;
              log('offer ready at', elapsed, 'ms');
              try { schedule(400, 'init'); } catch (e) { /* ignore */ }
            }
          } catch (e) { /* window access error – ignore */ }

          if (elapsed >= config.pollMaxTime) {
            clearInterval(id);
            log('poll stopped (timeout)');
          }
        } catch (e) {
          // Nếu interval callback throw → clear để tránh lặp lỗi vô hạn
          console.warn('[BSS AutoGift] poll tick error:', e);
          try { clearInterval(id); } catch (e2) { /* ignore */ }
        }
      }, config.pollInterval);
    } catch (e) { console.warn('[BSS AutoGift] poll start error:', e); }
  }

  /* ============================================================
     INIT
     ============================================================ */
  function init() {
    try { log('BSS AutoGift v3 init'); } catch (e) { /* ignore */ }
    try { patchFetch();       } catch (e) { console.warn('[BSS AutoGift] patchFetch failed:', e); }
    try { patchXHR();         } catch (e) { console.warn('[BSS AutoGift] patchXHR failed:', e); }
    try { listenCartEvents(); } catch (e) { console.warn('[BSS AutoGift] listenCartEvents failed:', e); }
    try { poll();             } catch (e) { console.warn('[BSS AutoGift] poll failed:', e); }
  }

  try {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();
  } catch (e) {
    console.warn('[BSS AutoGift] Startup error (script skipped):', e);
  }

})();
